import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, Outlet, useSearchParams, useLocation } from 'react-router-dom';

import { Loader } from '../loader';

interface Auth0InitGateProps {
  accessDeniedPath: string;
  emailVerificationPath: string;
}

export const Auth0InitGate = ({ accessDeniedPath, emailVerificationPath }: Auth0InitGateProps) => {
  const { isLoading } = useAuth0();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');

  if (error === 'access_denied') {
    const isEmailVerificationError = errorDescription?.toLowerCase().includes('email must be verified');
    if (isEmailVerificationError) {
      return <Navigate to={emailVerificationPath} replace />;
    }

    if (location.pathname !== accessDeniedPath) {
      return <Navigate to={`${accessDeniedPath}?${searchParams.toString()}`} replace />;
    }
  }

  if (isLoading) {
    return <Loader fullScreen />;
  }

  return <Outlet />;
};
